export const MANUAL_FLOW_MESSAGE =
    'System was unable to fetch all the information, please continue by selecting the model from the dropdown below';

export const MANUAL_FLOW_UNAVAILABLE_MESSAGE =
    'System was unable to fetch vehicle information. Please verify the VIN number and try again.';

export const getManualFlowMessage = (isManualFlowEnabled: boolean): string =>
    isManualFlowEnabled ? MANUAL_FLOW_MESSAGE : MANUAL_FLOW_UNAVAILABLE_MESSAGE;

export const SERVICE_UNAVAILABLE_ERROR_CODE = 'ERR003';
export const DETAILS_NOT_FOUND_ERROR_CODE = 'ERR003';
export const VALIDATION_SERVICE_UNAVAILABLE_ERROR_CODE = 'ERR005';

export const getErrorMessage = (errorCode?: string) => {
    switch (errorCode) {
        case SERVICE_UNAVAILABLE_ERROR_CODE:
            return 'Service unavailable';
        case DETAILS_NOT_FOUND_ERROR_CODE:
            return 'Details not found';
        case VALIDATION_SERVICE_UNAVAILABLE_ERROR_CODE:
            return 'Validation service unavailable';
        default:
            return 'Vin Validation failed';
    }
};
